module.exports = __webpack_public_path__ + "img/HARDWARE_MV.cde5bc9e.png";